import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
// 引入全局的样式文件
import './assets/css/global.less'
// elememt ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// 封装配置请求路径
axios.defaults.baseURL = 'http://123.7.77.164:8029'
// 将axios挂载到vue的原型对象上
// 在别的组件中this.$http
Vue.prototype.$http = axios
// 定义全局变量
Vue.prototype.$timer = null;

// 启动定时器
Vue.prototype.$startTimer = function () {
  if (this.$timer) return; // 防止重复启动
  this.$timer = setInterval( () => {
    this.getData()
      
    // 在这里执行定时任务，例如更新全局数据
  }, 300000); // 每 1 秒执行一次
};

// 停止定时器
Vue.prototype.$stopTimer = function () {
  if (this.$timer) {
    clearInterval(this.$timer);
    this.$timer = null;
  }
};
// 将全局的echarts对象挂载到vue的原型对象上
// 别的组件中 this.$echarts
Vue.prototype.$echarts = window.echarts
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.$startTimer(); // 在 Vue 实例创建时启动定时器
    this.getData()
  },
  beforeDestroy() {
    this.$stopTimer(); // 在 Vue 实例销毁时停止定时器
  },
  methods: {
    async getData() {
      const { data: ret } = await axios.get("https://devapi.qweather.com/v7/weather/now?location=101180508&key=0ecd32942e7d44b1b935310d34d8bac3");
      Vue.prototype.$globalConfig={data:ret.now.temp}
      console.log(this.$globalConfig.data);
      
  },
  }
}).$mount('#app')
